import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { Partido, PartidoJSON } from './Partido';
import { CampoJuego, CampoJuegoJSON } from '../CampoJuego/CampoJuego';
import { DateTime } from 'luxon';
import { Arbitro, ArbitroJSON } from '../Arbitro/Arbitro';

export interface PartidoConfigFromFixture {
  par_id: string;
  par_arbid_1: number;
  par_arbid_2: number;
  par_cjid: number;
  par_fecha: Date;
  par_horario: string;
}

export interface ControlOverlapJSON {
  fecha: string;
  campoJuego: CampoJuegoJSON;
  partidos: PartidoJSON[];
}
export interface ControlOverlapWrapper {
  fecha: string;
  data: ControlOverlap[];
}

export interface ControlOverlap {
  campoJuego: CampoJuego;
  partidos: Partido[];
}

export class PartidoSystem {
  private readonly base = '/partidos';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getPartidoIdentifiedBy(id: string): Promise<Partido> {
    const data = await this.requestHandler.get<PartidoJSON>(`${this.base}/${id}`);
    return Partido.fromJSON(data);
  }

  async getList(): Promise<Partido[]> {
    const data = await this.requestHandler.get<PartidoJSON[]>(`${this.base}`);
    return data.map((entity) => Partido.fromJSON(entity));
  }

  async getListForDropdown(): Promise<Partido[]> {
    const data = await this.requestHandler.get<PartidoJSON[]>(`${this.base}/for-dropdown`);
    return data.map((entity) => Partido.fromJSON(entity));
  }

  async save(entity: Partido) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<PartidoJSON, PartidoJSON>(this.base, data);
    return Partido.fromJSON(savedEntity);
  }

  // async contextForQuickEdit(): Promise<{ campoJuegoList: CampoJuego[]; arbitroList: Arbitro[] }> {
  //   const data = await this.requestHandler.get<{
  //     campoJuegoList: CampoJuegoJSON[];
  //     arbitroList: ArbitroJSON[];
  //   }>(`${this.base}/context-for-quick-edit`);

  //   return {
  //     campoJuegoList: data.campoJuegoList.map((e) => CampoJuego.fromJSON(e)),
  //     arbitroList: data.arbitroList.map((e) => Arbitro.fromJSON(e)),
  //   };
  // }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }

  getBaseUrlForDatagridForProgramados() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid-programados`);
  }

  async saveConfig(entity: Partido) {
    const data: PartidoConfigFromFixture = {
      par_id: entity.getId()!,
      par_arbid_1: entity.getArbid1()!,
      par_arbid_2: entity.getArbid2()!,
      par_cjid: entity.getCjid()!,
      par_fecha: entity.getFecha(),
      par_horario: entity.getHorario(),
    };
    const savedEntity = await this.requestHandler.post<PartidoJSON, PartidoConfigFromFixture>(
      `${this.base}/save-config-in-torneo`,
      data
    );
    return Partido.fromJSON(savedEntity);
  }

  async getOverlapPdf(from: Date, to: Date, fedId: string): Promise<unknown> {
    const _from = DateTime.fromJSDate(from).toFormat('yyyy-LL-dd');
    const _to = DateTime.fromJSDate(to).toFormat('yyyy-LL-dd');

    this.requestHandler.open(`${this.base}/overlap-pdf?desde=${_from}&hasta=${_to}&fedId=${fedId}`);
    return null;
  }

  async getOverlap(from: Date, to: Date, fedId: string): Promise<ControlOverlapWrapper[]> {
    const _from = DateTime.fromJSDate(from).toFormat('yyyy-LL-dd');
    const _to = DateTime.fromJSDate(to).toFormat('yyyy-LL-dd');
    const res = await this.requestHandler.get<ControlOverlapJSON[]>(
      `${this.base}/overlap?desde=${_from}&hasta=${_to}&fedId=${fedId}`
    );

    var datosAgrupados: any = {};

    for (var i = 0; i < res.length; i++) {
      var elemento = res[i];
      var fecha = elemento.fecha;

      if (!datosAgrupados[fecha]) {
        datosAgrupados[fecha] = {
          fecha: fecha,
          data: [
            {
              campoJuego: CampoJuego.fromJSON(elemento.campoJuego),
              partidos: elemento.partidos.map((p) => Partido.fromJSON(p)),
            },
          ],
        };
      } else {
        datosAgrupados[fecha].data.push({
          campoJuego: CampoJuego.fromJSON(elemento.campoJuego),
          partidos: elemento.partidos.map((p) => Partido.fromJSON(p)),
        });
      }
    }

    let resultado = Object.values(datosAgrupados) as ControlOverlapWrapper[];
    resultado.sort(function (a, b) {
      var fechaA = new Date(a.fecha);
      var fechaB = new Date(b.fecha);
      return fechaA.getTime() - fechaB.getTime();
    });
    console.log('resultado > ', resultado);

    return resultado;
  }

  async cedePuntos(partidoId: string): Promise<{ ok: number; error: number }> {
    return await this.requestHandler.put(`${this.base}/cede-puntos/${partidoId}`, {});
  }

  async cedePuntosAmbos(partidoId: string): Promise<{ ok: number; error: number }> {
    return await this.requestHandler.put(`${this.base}/cede-puntos/${partidoId}?ningunoPresenta=1`, {});
  }

  async cedePuntosEquipoEspecifico(
    partidoId: string,
    equipoId: string
  ): Promise<{ ok: number; error: number }> {
    return await this.requestHandler.put(
      `${this.base}/cede-puntos-equipo-especifico/${partidoId}/${equipoId}`,
      {}
    );
  }

  async programarPartido(partidoId: string): Promise<any> {
    return await this.requestHandler.put(`${this.base}/programar/${partidoId}`, {});
  }

  async programarMultiplesPartidos(partidosIds: string[]): Promise<any> {
    return await this.requestHandler.put(`${this.base}/programar-multiples-partidos`, {
      partidoIds: partidosIds,
    });
  }
}
